import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/AuthProvider';
import DeveloperControlPanel from '../components/developer/DeveloperControlPanel';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import app from '../Firebase';

// Protected Route component for developer-only access
const ProtectedDeveloperRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const { currentUser, loading } = useAuth();
  
  // Check if the user has the DEVELOPER permission
  const [isDeveloper, setIsDeveloper] = useState<boolean | null>(null);
  const [checkingPermission, setCheckingPermission] = useState<boolean>(true);
  
  // Fetch user permissions to check for DEVELOPER role
  useEffect(() => {
    const checkDeveloperPermission = async () => {
      if (!currentUser || !currentUser.email) {
        setIsDeveloper(false);
        setCheckingPermission(false);
        return;
      }
      
      try {
        const db = getFirestore(app);
        const userDocRef = doc(db, 'users', currentUser.email);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const userPermissions = userData?.permissions || [];
          setIsDeveloper(userPermissions.includes('DEVELOPER'));
        } else {
          setIsDeveloper(false);
        }
      } catch (error) {
        console.error('Error checking developer permission:', error);
        setIsDeveloper(false);
      } finally {
        setCheckingPermission(false);
      }
    };
    
    if (currentUser) {
      checkDeveloperPermission();
    } else if (!loading) {
      setIsDeveloper(false);
      setCheckingPermission(false);
    }
  }, [currentUser, loading]);
  
  if (loading || checkingPermission) {
    return <div className="loading">Loading...</div>;
  }
  
  if (!currentUser) {
    return <Navigate to="/login?redirect=/cp" replace />;
  }
  
  if (!isDeveloper) {
    return <Navigate to="/" replace />;
  }
  
  return element;
};

const DeveloperRoute: React.FC = () => {
  const db = getFirestore(app);
  // const functions = getFunctions(app, "europe-west2");
  const functions = getFunctions(app, 'europe-west2');
  
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedDeveloperRoute 
          element={<DeveloperControlPanel db={db} functions={functions} />} 
        />
      } />
    </Routes>
  );
};

export default DeveloperRoute;